import Vue from 'vue';
import VTitle from './v-title';
import VMetaDescription from './v-meta-description';

Vue.directive('title', VTitle);
Vue.directive('metaDescription', VMetaDescription);
